import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  kdsList: [],
  kdsObj: null,
  kds: null,
  kdsReceipt: null,
  receiptList: [],
  selectedCategories :[]
}

const slice = createSlice({
  name: "kds",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getKdsSuccessSingle(state, action) {
      state.isLoading = false;
      state.kds = action.payload;
    },

    getKdsReceiptListSuccess(state, action) {
      state.isLoading = false;
      state.receiptList = action.payload;
    },
    getKdsReceiptSuccessSingle(state, action) {
      state.isLoading = false;
      state.kdsReceipt = action.payload;
    },
    getSelectedSuccessCategories(state, action) {
      state.isLoading = false;
      state.selectedCategories = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getKdsSingle(kitchenId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/kds/${kitchenId}`);
      dispatch(slice.actions.getKdsSuccessSingle(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


// kitchen receipt


export function getAllKdsReceiptList(venueId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/venueReceipt?venueId=${venueId}`);
      dispatch(slice.actions.getKdsReceiptListSuccess(response.data.results));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function updateKdsReceipt(data, id) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    try {
      const state = getState();
      const receipts = state.kds.receiptList || [];

      if (data.default === true) {
        const updatedReceipts = receipts.map(receipt => {
          if (receipt.default && receipt.id !== id) {
            return { ...receipt, default: false };
          }
          if (receipt.id === id) {
            return { ...receipt, ...data };
          }
          return receipt;
        });
        dispatch(slice.actions.getKdsReceiptListSuccess(updatedReceipts));
      }
      await axios.patch(`${backendUrl}/venueReceipt/${id}`, data);
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}



export function getKdsReceiptSingle(kitchecReceiptId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/venueReceipt/${kitchecReceiptId}`);
      dispatch(slice.actions.getKdsReceiptSuccessSingle(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getSelectedCategories(cat) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.getSelectedSuccessCategories(cat));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
